import { render, staticRenderFns } from "./DescargoPage.vue?vue&type=template&id=faf390e2"
import script from "./DescargoPage.js?vue&type=script&lang=js&external"
export * from "./DescargoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports